import { PAYMENT_MODEL_ENUM } from '@nxsys/constants/AppEnums';
import { AppState } from '@nxsys/store';
import { IRELAND } from '@nxsys/store/constants/keys';
import { useSelector } from 'react-redux';

// Shared by the form (what it renders) and the tab (what it saves): a field
// the form does not render has no value, so saving it would overwrite the
// stored one with a blank.
export const useCompanyDetailFieldVisibility = (paymentModel?: string[]) => {
  const { payrollCountry, isBureau, isBureauEmployer } = useSelector(
    (state: AppState) => state.appStore,
  );
  const isIreland = payrollCountry === IRELAND;
  const showVat = !isBureau || !isBureauEmployer;

  return {
    showCis:
      !isIreland &&
      (paymentModel?.includes(PAYMENT_MODEL_ENUM.CIS) ||
        paymentModel?.includes(PAYMENT_MODEL_ENUM.NON_CIS)),
    // The employer login must not see VAT at all (NX-5490).
    showVat,
    // NX-5228: VAT Method offers Standard or Flat Rate VAT. The Flat Rate
    // Scheme is an HMRC scheme; Irish Revenue runs none for an ordinary
    // business, and no calculation reads the value — it is only printed on
    // the UK self-bill. Country-scoped, so it applies to both products.
    showVatMethod: showVat && !isIreland,
  };
};
